module.exports = __webpack_public_path__ + "files/d050282b3d815d83b9fa6258a637eaef.png";